import { render } from "./app.vue?vue&type=template&id=c7a4d33c"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladbiletski/Documents/Work/apps/dev/qt-lite-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__